import $ from "jquery";

import "./main";
import * as bootstrap from "bootstrap";

window.$ = $;
window.jQuery = $;

$(window).on("scroll", () => {
    const currentScroll = $(window).scrollTop();
    if (currentScroll >= 150 && $(window).width() >= 968) {
        $("#stuck_container").addClass("isStuck");
        $("#stuck_container").slideDown();
        $("#toTop").fadeIn();
    } else {
        $("#stuck_container").removeClass("isStuck");
        $("#toTop").fadeOut();
    }
});

$("#toTop").on("click", () => {
    $(window).scrollTop(0);
});

$(".mobile-menu-item i").on("click", (e) => {
    const parent = $(e.currentTarget).parent();
    $(".mobile-menu-item").not(parent).removeClass("open").find(".mobile-submenu").slideUp();
    $(e.currentTarget).parent().toggleClass("open");
    parent.find(".mobile-submenu").slideToggle()
});
